import type { Segment } from '../types';

export function convertSegmentValueKeysToNames(clauseValues: unknown[], segments: Segment[]) {
  return clauseValues.map((value) => {
    const segment = segments.find((s) => s.key === value);
    return segment?.name || value;
  });
}
